import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=0f05b186"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f05b186')) {
      api.createRecord('0f05b186', component.options)
    } else {
      api.reload('0f05b186', component.options)
    }
    module.hot.accept("./GoodsList.vue?vue&type=template&id=0f05b186", function () {
      api.rerender('0f05b186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/shop/GoodsList.vue"
export default component.exports